import { ShellPanelToggle } from '@/components/layout/shell'
import { useShellChrome } from '@/components/layout/resizable-layout.flyout'
import { testIds } from '@/lib/test-ids'
import { FileText } from 'lucide-react'

export function ChatPaneDropZoneOverlay() {
  return (
    <div className="absolute inset-0 z-50 pointer-events-none flex items-center justify-center bg-primary/5 border-2 border-dashed border-primary/30 rounded-lg m-2">
      <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-card border border-primary/30 shadow-lg">
        <FileText className="h-4 w-4 text-primary" />
        <span className="text-sm font-medium text-primary">Drop to add as reference</span>
      </div>
    </div>
  )
}

export function ChatPaneCollapsedState({
  onToggleCollapse,
}: {
  onToggleCollapse?: () => void
}) {
  const { agentDisabledReason } = useShellChrome()
  return (
    <div className="flex h-full flex-col items-center">
      <ShellPanelToggle
        side="agent"
        placement="slot"
        open={false}
        disabledReason={agentDisabledReason}
        onToggle={() => onToggleCollapse?.()}
        testId={testIds.chatPane.collapseButton}
      />
    </div>
  )
}
